import { motion } from "framer-motion";
import { FadeUp, MaskedLines, Chapter } from "@/components/motion";
import { CTAButton } from "@/components/CTA";

const CARDS = [
  {
    img: "https://images.unsplash.com/photo-1726835498689-b4f6dbcdbdfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjByZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBkYXJrfGVufDB8fHx8MTc4OTY1MTAzN3ww&ixlib=rb-4.1.0&q=85",
    alt: "Interior de restaurante",
    tag: "RESTAURANTES",
    text: "Si falla la climatización en pleno servicio, cada hora cuenta. Notificas y sigues atendiendo mesas.",
  },
  {
    img: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxzbWFsbCUyMGJvdXRpcXVlJTIwc3RvcmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODk2NTEwMzd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Interior de tienda",
    tag: "TIENDAS",
    text: "Una avería eléctrica no debería cerrar tu persiana. Aprea gestiona mientras tú vendes.",
  },
];

const TYPES = ["PELUQUERÍAS", "CENTROS DE ESTÉTICA", "OFICINAS PEQUEÑAS", "COMERCIO DE PROXIMIDAD"];

export default function ParaComercios() {
  return (
    <main data-testid="page-para-comercios" className="pt-40 lg:pt-48">
      <header className="mx-auto max-w-[1500px] px-6 lg:px-12 pb-24 lg:pb-32">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-mono text-[11px] tracking-[0.4em] text-glow/80 mb-8"
        >
          PARA COMERCIOS
        </motion.p>
        <h1 className="font-display font-800 uppercase leading-[0.95] tracking-tight text-[11vw] sm:text-7xl lg:text-8xl text-offwhite max-w-6xl">
          <MaskedLines
            mode="load"
            delay={0.3}
            lines={[
              <span key="a">Pensado para un negocio</span>,
              <span key="b" className="font-cormorant normal-case font-medium text-metal">como el tuyo.</span>,
            ]}
          />
        </h1>
      </header>

      <section className="border-t border-silver/10 py-24 lg:py-32">
        <div className="mx-auto max-w-[1500px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {CARDS.map((c, i) => (
            <FadeUp key={c.tag} delay={i * 0.1}>
              <figure className="group relative border border-silver/15 overflow-hidden">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.alt}
                    loading="lazy"
                    className="h-full w-full object-cover grayscale-[35%] contrast-110 brightness-[0.65] transition-[transform,filter] duration-700 group-hover:scale-[1.03] group-hover:grayscale-0"
                  />
                  <span className="absolute top-4 left-4 w-5 h-5 border-t border-l border-silver/60" />
                  <span className="absolute bottom-4 right-4 w-5 h-5 border-b border-r border-silver/60" />
                  <span className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.3em] text-silver/90 bg-night/70 backdrop-blur px-3 py-2">
                    {c.tag}
                  </span>
                </div>
                <figcaption className="p-8 bg-panel/50">
                  <p className="text-mist leading-relaxed">{c.text}</p>
                </figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>

        <div className="mx-auto max-w-[1500px] px-6 lg:px-12 mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-silver/10">
          {TYPES.map((t, i) => (
            <FadeUp key={t} delay={i * 0.05} y={20}>
              <div className="border-b border-r border-silver/10 p-8 h-full">
                <span className="font-mono text-[10px] text-steel block mb-6">{String(i + 3).padStart(2, "0")}</span>
                <span className="font-oswald font-500 uppercase text-lg tracking-wide text-mist">{t}</span>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="bg-abyss border-y border-silver/10 py-24 lg:py-32">
        <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
          <Chapter num="01" label="LA REALIDAD DEL PEQUEÑO COMERCIO" className="mb-12" />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
            <FadeUp className="lg:col-span-7">
              <p className="font-display font-700 text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-offwhite">
                En un pequeño comercio no hay departamento de mantenimiento.{" "}
                <span className="text-mist">Hay alguien que lo hace todo.</span>
              </p>
            </FadeUp>
            <FadeUp delay={0.15} className="lg:col-span-5">
              <p className="text-mist leading-relaxed mb-8">
                Y cuando algo falla, ese alguien deja de atender el negocio para ponerse a buscar técnicos.
                Aprea existe para que eso no vuelva a pasar: una cuota mensual y un único punto de contacto para
                cualquier incidencia física de tu local.
              </p>
              <CTAButton testid="comercios-cta-alta">PROTEGER MI COMERCIO</CTAButton>
            </FadeUp>
          </div>
        </div>
      </section>
    </main>
  );
}
